module.exports = __webpack_public_path__ + "img/start.2fbaae9f.svg";